import styled, { StyledComponent } from '@emotion/styled'
import {
  FontAwesomeIcon,
  FontAwesomeIconProps,
} from '@fortawesome/react-fontawesome'
import { ColorProps } from 'styled-system'

import { themeColor } from '../Theme/utils'
import './library.ts'

export const Icon: StyledComponent<FontAwesomeIconProps, ColorProps> = styled(
  FontAwesomeIcon,
)`
  path {
    fill: ${props => themeColor(props.color)};
  }
`
Icon.defaultProps = {
  color: 'primary',
}
